"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignDeviceException = void 0;
class AssignDeviceException extends Error {
    constructor(message) {
        super(message);
        this.name = "AssignDeviceException";
    }
}
exports.AssignDeviceException = AssignDeviceException;
